import cn from 'classnames';
import { PropsWithChildren } from 'react';

import { ComponentProps } from 'src/types/component-props';
import { FeaturedItemData } from 'src/types/components';

import ActionIcon from '../ActionIcon';
import { IconType } from '../ActionIcon/ActionIcon';
import Image from '../Image';
import Link from '../Link';
import RichText from '../RichText';
import Text from '../Text';

import styles from './FeaturedItem.module.scss';

export type FeaturedItemProps = ComponentProps & FeaturedItemData;

type DivWrapperProps = {
  className?: string;
};

const DivWrapper = (props: PropsWithChildren<DivWrapperProps>): JSX.Element => (
  <div className={props.className}>{props.children}</div>
);

const FeaturedItem = ({ fields }: FeaturedItemProps): JSX.Element => {
  const { eyebrow, heading, image, description, url } = fields;

  const hasLink = url?.href;

  const LinkOrDiv = hasLink ? Link : DivWrapper;

  let iconType: IconType = 'long';
  if (url?.href.includes('tel:')) {
    iconType = 'telephone';
  } else if (url?.href.includes('mailto:')) {
    iconType = 'email';
  }

  return (
    <LinkOrDiv className={styles.featuredItem} {...url}>
      <article className={styles.box}>
        <div className={styles.boxAnchor}>
          <div className={styles.content}>
            {eyebrow && <Text className={styles.eyebrow} tag="div" field={eyebrow} />}
            <Text className={styles.heading} tag="h3" field={heading} />
            {description && <RichText className={styles.copy} field={description} />}
          </div>

          {hasLink && (
            <ActionIcon className={cn(styles.icon, styles[`icon--${iconType}`])} type={iconType} />
          )}
        </div>
      </article>
      {!!image && (
        <figure className={styles.imageFigure}>
          <Image fill {...image} />
        </figure>
      )}
    </LinkOrDiv>
  );
};

export default FeaturedItem;
